import React, { useRef } from 'react';
import Select from 'react-select';
import { RiRefreshLine } from 'react-icons/ri';
import { FaFileCircleExclamation } from 'react-icons/fa6';

const selectTheme = (theme) => ({ ...theme, borderRadius: 5, padding: 9 });
const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
    color: '#000 ',
    ':hover': { backgroundColor: '#F5F5F5', color: '#000 ' },
  }),
};

const ControlPanel = ({
  formats,
  bankFormat,
  onFormatChange,
  file,
  onFileChange,
  sheetName,
  canValidate,
  onValidate,
  hasRows,
  onRefresh,
  onReset,
  onExport,
  onPrint,
  disabled,
}) => {
  const fileInput = useRef(null);
  const options = (formats || []).map((f) => ({ value: f.value, label: f.text }));
  const selected = options.find((o) => o.value === bankFormat) || null;

  const handleFile = (e) => {
    const chosen = e.target.files?.[0] || null;
    onFileChange(chosen);
    // Allow picking the same file again after a format change or reset.
    if (fileInput.current) fileInput.current.value = '';
  };

  return (
    <div className="row g-2 align-items-center">
      <div className="col-12 col-md-3">
        <Select
          className="p-0"
          theme={selectTheme}
          menuPortalTarget={document.body}
          styles={selectStyles}
          placeholder="Select Bank Format"
          value={selected}
          options={options}
          isDisabled={disabled}
          onChange={(opt) => onFormatChange(opt?.value || '')}
        />
      </div>
      <div className="col-12 col-md-4">
        <div className="d-flex align-items-center gap-2">
          <input
            ref={fileInput}
            type="file"
            accept=".xlsx,.xlsm"
            className="form-control"
            disabled={!bankFormat || disabled}
            onChange={handleFile}
          />
        </div>
        <div className="small text-muted mt-1">
          {file ? <span className="me-2">{file.name}</span> : null}
          {bankFormat && sheetName ? <span>reads worksheet: {sheetName}</span> : null}
        </div>
      </div>
      <div className="col-12 col-md-5 d-flex flex-wrap gap-2 justify-content-md-end">
        <button type="button" className="mainbtn" disabled={!canValidate || disabled} onClick={onValidate}>
          <FaFileCircleExclamation color="#fff" className="center mt-1 mx-2" />
          <div>Validate</div>
        </button>
        {hasRows ? (
          <button type="button" className="mainbtnGry" disabled={disabled} onClick={onRefresh}>
            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
            <div>Refresh</div>
          </button>
        ) : null}
        <button type="button" className="mainbtnRed" disabled={disabled} onClick={onReset}>
          <div>Reset</div>
        </button>
        <button type="button" className="mainbtnSecondary" disabled={!hasRows || disabled} onClick={onExport}>
          <div>Export</div>
        </button>
        <button type="button" className="mainbtnSecondary" disabled={!hasRows || disabled} onClick={onPrint}>
          <div>Print</div>
        </button>
      </div>
    </div>
  );
};

export default ControlPanel;
